"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.providers = exports.targetingsV1 = void 0;
const list = (caller) => ({ accountId }) => {
    const query = { _max_per_page: 0 };
    return caller(`/accounts/${accountId}/targetings`).get(query);
};
const getProvider = (caller) => ({ accountId, providerId }) => {
    return caller(`/accounts/${accountId}/providers/${providerId}`).get();
};
const getProviders = (caller) => ({ accountId }) => {
    return caller(`/accounts/${accountId}/providers`).get();
};
const segmentsList = (caller) => ({ accountId, dbName }) => {
    return caller(`/backend/accounts/${accountId}/${dbName}/segments`).get();
};
const segmentValuesList = (caller) => ({ accountId, dbName, segmentName, search }) => {
    const query = {
        pattern: search,
    };
    return caller(`/backend/accounts/${accountId}/${dbName}/segments/${segmentName}/values`).get(query);
};
const targetingsV1 = (caller) => ({
    list: list(caller),
    getProvider: getProvider(caller),
    getProviders: getProviders(caller),
});
exports.targetingsV1 = targetingsV1;
const providers = (caller) => ({
    segmentsList: segmentsList(caller),
    segmentValuesList: segmentValuesList(caller),
});
exports.providers = providers;
//# sourceMappingURL=api.js.map